export const HANDLE_INTENT = 'HANDLE_INTENT';
export const CLEAR_INTENT = 'CLEAR_INTENT';
